import {jsPDF} from "jspdf";
import {
    standardQuoteImageX,
    standardQuoteImageY,
    standardQuoteImageWidth,
    standardQuoteImageHeight, defaultFontSize
} from "./PDFGenerationUtils";

import EnrolmentForms_En3 from "./PageGenerators/Enrolment Forms/EnrolmentForms_En3";
import EnrolmentForms_En2 from "./PageGenerators/Enrolment Forms/EnrolmentForms_En2";
import CreditCard_En1 from "./PageGenerators/Credit Card/CreditCard_En1";
import IllustrationDisclosure_GroupEn1 from "./PageGenerators/Illustration Disclosure/IllustrationDisclosure_GroupEn1";

export const generateEnrolmentDocumentPDFToBlob = (data, quote) => {
    const doc = generateEnrolmentDocumentPDF(data, quote);
    return doc.output("blob");
}

//Creates a PDF document with the given data as a demonstration of what is possible
// TODO this is unused?
export const generateEnrolmentDocumentPDF = (data, quote) => {
    let doc = new jsPDF();

    doc.setFontSize(defaultFontSize);


    //Quotation page
    doc.addImage(quote, "PNG", standardQuoteImageX, standardQuoteImageY, standardQuoteImageWidth, standardQuoteImageHeight, 'QUOTE', 'FAST');
    doc.addPage();

    // Illustration
    IllustrationDisclosure_GroupEn1.generate(doc, data);
    doc.addPage();

    //Enrolment forms
    EnrolmentForms_En2.generate(doc, data);
    doc.addPage();
    EnrolmentForms_En3.generate(doc, data);
    doc.addPage();
    CreditCard_En1.generate(doc, data);

    return doc;
}

export const generatePDFToFile = (data) => {
    let doc = generateEnrolmentDocumentPDF(data);
    doc.save("enrolment-form.pdf");
}